import { Tooltip, Typography } from "@material-ui/core";
import { formatFieldValue } from "./listagemDiferencas";

export const SpecialFieldRender: React.FC<{
    value: string;
    fieldType: string;
    isOldValue?: boolean;
    classes: any;
}> = ({ value, fieldType, isOldValue = false, classes }) => {
    const formattedValue = formatFieldValue(value);
    const valueClass = isOldValue ? classes.oldValue : classes.newValue;

    if (fieldType === 'complex-object' && value !== 'null' && value !== 'N/A') {
        return (
            <div className={classes.complexValue}>
                <Typography variant="caption" component="div">
                    {formattedValue}
                </Typography>
            </div>
        );
    }

    if (fieldType === 'array-count') {
        return (
            <div className={classes.countChange}>
                <span className="count-badge">{formattedValue}</span>
                <Typography variant="caption" color="textSecondary">
                    {isOldValue ? 'anterior' : 'novo'}
                </Typography>
            </div>
        );
    }

    if (fieldType === 'guid' && value !== 'null' && value !== 'N/A') {
        return (
            <Tooltip title={formattedValue}>
                <Typography className={valueClass} style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {formattedValue.substring(0, 8)}...
                </Typography>
            </Tooltip>
        );
    }

    return (
        <Typography className={valueClass}>
            {formattedValue}
        </Typography>
    );
};